import { useRef, useState } from 'react';

interface UseBarcodeReaderParams {
  onDecode: (decodedCode: string) => void;
}

const useBarcodeReader = ({ onDecode }: UseBarcodeReaderParams) => {
  const [isOpen, setIsOpen] = useState(false);
  const isReadingBlockedRef = useRef(false);

  const open = () => {
    isReadingBlockedRef.current = false;
    setIsOpen(true);
  };

  const close = () => {
    isReadingBlockedRef.current = true;
    setIsOpen(false);
  };

  const handleSuccess = (decodedCode: string) => {
    if (isReadingBlockedRef.current) {
      return;
    }

    isReadingBlockedRef.current = true;
    setIsOpen(false);
    onDecode(decodedCode);
  };

  return { isOpen, open, close, handleSuccess };
};

export default useBarcodeReader;
